export default {
    open: {
        id: 1,
        behavior: 'open',
        name: 'New'
    },
    start: {
        id: 2,
        behavior: 'start',
        name: 'In progress'
    },
    close: {
        id: 3,
        behavior: 'close',
        name: 'Closed'
    },
    completed: {
        id: 4,
        behavior: 'close',
        name: 'Completed'
    }
};



// WEBPACK FOOTER //
// ./src/lib/discussionStatuses.ts